import React from "react";
import { Link } from 'react-router-dom';
import StatusCard from "../Cards/StatusCard";
import AddNewButton from "../Buttons/AddNewButton";

const BinStatus = (props) => {
    // "https://drive.google.com/uc?export=view&id=1__h73dKYlAVSoaLhNPt3ZGdBlX1DI7BY"
   
    return(
        <div className="max-w-screen-xl px-4 mx-auto">
            <div className="flex items-center justify-between mb-4 binhead">
                <h3 className="mb-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white">Bin Status</h3>
                <div className="">
                    <Link to={'/addNewBin'}><AddNewButton innerTxt={"+ Add New Bin"}/></Link>
                    
                </div>
            </div>
            <div className="flex gap-x-3 ">
                <StatusCard cardWidth={"w-1/3"} color="text-green-500" cardhead="Filled Bins" CardVal={props.filledBins} closeToFillShow={false} imgShow={true} imgImage={"https://drive.google.com/uc?export=view&id=1__h73dKYlAVSoaLhNPt3ZGdBlX1DI7BY"}/>
                <StatusCard cardWidth={"w-1/3"} color="text-white" cardhead="Active Bins" CardVal={props.activeBins} closeToFillShow={true} closeToFillCount={props.closeToFill} imgShow={true} imgImage={"https://drive.google.com/uc?export=view&id=1JNyvf1fenxW3uwtZIKrM3-zkZH-mTPiF"} />
                {/* <StatusCard cardWidth={"w-1/3"} color="text-red-500" cardhead="Broken Bins" CardVal={props.brokenBins} closeToFillShow={false} imgShow={true} imgImage={"https://pngimg.com/d/recycle_bin_PNG45.png"}/> */}
            </div>
        </div>
    )
}

export default BinStatus